import { ANALYTICS_EVENTS } from './events'
import type { AnalyticsLocation } from './params'
import { trackSiteEvent } from './site-event'

/**
 * The `target` value for `site_link_clicked`: an in-site path with its anchor
 * (`/transcription#try`), a same-page anchor on its own (`#try`), or the host of
 * an external link. The query string is always dropped — it is where utm tags
 * and referral codes live, and a param value must never carry them.
 */
export function siteLinkTarget(href: string): string {
  if (href.startsWith('#')) return href
  const external = /^([a-z][a-z0-9+.-]*):(?:\/\/(?:[^/?#@]*@)?([^/?#]+))?/i.exec(href)
  // An absolute URL reports its host, never the credentials before `@`; a
  // scheme without a host, like `mailto:`, reports the scheme.
  if (external) return external[2] ?? external[1].toLowerCase()
  const [beforeHash, hash] = href.split('#', 2)
  const path = beforeHash.split('?', 1)[0]
  return hash === undefined ? path : `${path}#${hash}`
}

/** Report a click on a marketing-site link or CTA. Call from the link's `onClick`. */
export function trackSiteLinkClicked(location: AnalyticsLocation, href: string): void {
  trackSiteEvent(ANALYTICS_EVENTS.siteLinkClicked, { location, target: siteLinkTarget(href) })
}
